import { render, staticRenderFns } from "./ClientVerificationPopUp.vue?vue&type=template&id=56791168&scoped=true&"
import script from "./ClientVerificationPopUp.vue?vue&type=script&lang=js&"
export * from "./ClientVerificationPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ClientVerificationPopUp.vue?vue&type=style&index=0&id=56791168&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56791168",
  null
  
)

export default component.exports